import script from "./concatUs.vue?vue&type=script&setup=true&lang=js"
export * from "./concatUs.vue?vue&type=script&setup=true&lang=js"

import "./concatUs.vue?vue&type=style&index=0&id=42f587b3&lang=css"

const __exports__ = script;

export default __exports__